import { CreditCardBill, BillPayment, BillFormData } from '@/types/bill';
import { Transaction } from '@/types';

export const createBillForCard = (
  cardId: string,
  periodEnd: string,
  cardTransactions: Transaction[],
  dueDate: number
): CreditCardBill => {
  const endDate = new Date(periodEnd);
  const startDate = new Date(endDate);
  startDate.setMonth(startDate.getMonth() - 1);
  startDate.setDate(startDate.getDate() + 1);

  const totalAmount = cardTransactions.reduce((sum, t) => sum + Math.abs(t.amount), 0);

  const billDueDate = new Date(endDate);
  billDueDate.setMonth(billDueDate.getMonth() + 1);
  billDueDate.setDate(dueDate);

  return {
    id: Date.now().toString(),
    cardId,
    periodStart: startDate.toISOString().split('T')[0],
    periodEnd: periodEnd,
    totalAmount,
    paidAmount: 0,
    status: 'pendente',
    dueDate: billDueDate.toISOString().split('T')[0],
    createdAt: new Date().toISOString(),
    transactionIds: cardTransactions.map(t => t.id),
    paymentIds: []
  };
};

export const createPaymentRecord = (
  billId: string,
  paymentData: BillFormData,
  transactionId: string
): BillPayment => {
  return {
    id: Date.now().toString(),
    billId,
    amount: paymentData.amount,
    paymentDate: paymentData.paymentDate,
    accountId: paymentData.accountId,
    transactionId,
    createdAt: new Date().toISOString()
  };
};

export const updateBillAfterPayment = (
  bill: CreditCardBill,
  paymentAmount: number,
  paymentId: string
): CreditCardBill => {
  const newPaidAmount = bill.paidAmount + paymentAmount;
  let newStatus: 'pendente' | 'parcialmente_paga' | 'paga' = 'pendente';
  
  if (newPaidAmount >= bill.totalAmount) {
    newStatus = 'paga';
  } else if (newPaidAmount > 0) {
    newStatus = 'parcialmente_paga';
  }

  return {
    ...bill,
    paidAmount: newPaidAmount,
    status: newStatus,
    paymentIds: [...bill.paymentIds, paymentId]
  };
};

// Nova função para remover transação de uma fatura
export const removeTransactionFromBill = (
  bill: CreditCardBill,
  transactionId: string
): CreditCardBill => {
  const updatedTransactionIds = bill.transactionIds.filter(id => id !== transactionId);
  
  // Se não há mais transações, definir valor como 0
  if (updatedTransactionIds.length === 0) {
    return {
      ...bill,
      transactionIds: [],
      totalAmount: 0,
      status: bill.paidAmount > 0 ? 'paga' : 'pendente'
    };
  }

  // Recalcular o total baseado nas transações restantes seria necessário,
  // mas como não temos acesso às transações aqui, vamos assumir que será
  // recalculado externamente se necessário
  return {
    ...bill,
    transactionIds: updatedTransactionIds
  };
};
